import { useRef, useCallback } from 'react';

/**
 * Hook to cache user fetch promises and prevent duplicate in-flight requests.
 * Replaces the global window._userFetchPromises anti-pattern.
 */
export const useUserFetchCache = () => {
  const userFetchPromisesRef = useRef({});

  const getCachedPromise = useCallback((userId) => {
    return userFetchPromisesRef.current[userId];
  }, []);

  const setCachedPromise = useCallback((userId, promise) => {
    userFetchPromisesRef.current[userId] = promise;
  }, []);

  const removeCachedPromise = useCallback((userId) => {
    delete userFetchPromisesRef.current[userId];
  }, []);

  const clearAllPromises = useCallback(() => {
    userFetchPromisesRef.current = {};
  }, []);

  return {
    getCachedPromise,
    setCachedPromise,
    removeCachedPromise,
    clearAllPromises,
    // Expose ref for advanced use cases
    promisesRef: userFetchPromisesRef,
  };
};

export default useUserFetchCache;
